import { useServiceAuth } from '../../../hooks';
import { useGetUserProfileQuery } from '../../../graphql/queries/__generated__/GetUserProfile.graphql';
import React from 'react';
import { Skeleton } from '@lifeomic/chroma-react/components/Skeleton';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles } from '@lifeomic/chroma-react/styles';

const useStyles = makeStyles(_theme => ({
  skeletonBox: {
    display: 'inline-flex',
  },
}));

/**
 * A component which takes a user's id and renders their display name.
 */
export const ProfileInfo = ({ userId }: { userId: string }) => {
  const serviceAuth = useServiceAuth();
  const classes = useStyles();
  const context = {
    headers: {
      'LifeOmic-Account': serviceAuth.account,
      Authorization: `Bearer ${serviceAuth.authToken}`,
    },
  };
  const { data, loading } = useGetUserProfileQuery({
    context,
    variables: {
      id: userId,
    },
  });

  return loading ? (
    <Box className={classes.skeletonBox}>
      <Skeleton width={45} height={14} />
    </Box>
  ) : (
    <>{data?.user?.profile?.displayName || data?.user?.profile?.email}</>
  );
};
